import { render, staticRenderFns } from "./CreateStudio.vue?vue&type=template&id=89fa44b2&scoped=true"
import script from "./CreateStudio.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateStudio.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateStudio.vue?vue&type=style&index=0&id=89fa44b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fa44b2",
  null
  
)

export default component.exports